<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">{{ title }}</span>
    </p>
    <div style="position: relative;">
      <Spin v-if="loadingStatus" fix />
      <Form ref="parkingForm" :label-width="100" :model="formFields" :rules="ruleValidate">
        <FormItem label="车库名称:" prop="name">
          <Input v-model="formFields.name" placeholder="请输入车库名称..." size="small" />
        </FormItem>
        <FormItem label="车库类型:" prop="type">
          <!-- <Input v-model="formFields.capacity" placeholder="请输入车库容量..." size="small" number disabled /> -->
          <Select
            v-model="formFields.type"
            placeholder="请选择车库类型..."
            filterable
            size="small"
          >
            <Option v-for="(option, index) in parkingTypes" :key="index" :value="option.value" :label="option.title">
              <span>{{ option.title }}</span>
              <span style="float:right;color:#ccc">{{ option.description }}</span>
            </Option>
          </Select>
        </FormItem>
        <FormItem label="运营模式:" prop="businessType">
          <!-- <Input v-model="formFields.capacity" placeholder="请输入车库容量..." size="small" number disabled /> -->
          <Select
            v-model="formFields.businessType"
            placeholder="请选择车库运营模式..."
            filterable
            size="small"
          >
            <Option v-for="(option, index) in parkingBusinessType" :key="index" :value="option.value" :label="option.label" />
          </Select>
        </FormItem>
        <FormItem label="开放注册:" prop="isOpen">
          <Select
            v-model="formFields.isOpen"
            placeholder="请选择是否开放车辆绑定..."
            filterable
            size="small"
          >
            <Option v-for="(option, index) in parkingOpenTypes" :key="index" :value="option.value" :label="option.title">
              <span>{{ option.title }}</span>
            </Option>
          </Select>
        </FormItem>
        <FormItem label="车库城市:">
          <AreaCascader v-model="area" size="small" level="2" style="margin-top: 6px" data-type="name" @on-change="onAreaChange" />
        </FormItem>
        <FormItem label="运营日期:" prop="onlineDate">
          <DatePicker
            type="date"
            placeholder="请选择运营日期"
            size="small"
            style="width:100%"
            :value="formFields.onlineDate"
            @on-change="handleDateChange"
          />
        </FormItem>
        <FormItem label="车库容量:" prop="capacity">
          <!-- <Input v-model="formFields.capacity" placeholder="请输入车库容量..." size="small" number disabled /> -->
          <Select
            v-model="formFields.capacity"
            placeholder="请选择车库容量..."
            filterable
            size="small"
            :disabled="formFields.id > 0"
            @on-change="handleCapacityChange"
          >
            <Option v-for="(option, index) in segmentCapacity" :key="index" :value="option" :label="option" />
          </Select>
        </FormItem>
        <FormItem label="新老标志:" prop="isFresh">
          <!-- <Input v-model="formFields.capacity" placeholder="请输入车库容量..." size="small" number disabled /> -->
          <Select
            v-model="formFields.isFresh"
            placeholder="请选择车库新老标志..."
            filterable
            size="small"
          >
            <Option v-for="(option, index) in parkingFreshTypes" :key="index" :value="option.value" :label="option.title">
              <span>{{ option.title }}</span>
            </Option>
          </Select>
        </FormItem>

        <FormItem label="缓冲月份:" prop="bufferMonths">
          <Input v-model="formFields.bufferMonths" placeholder="请输入缓冲月份..." size="small" number />
        </FormItem>
        <FormItem label="开门次数:" prop="openingTimes">
          <Input v-model="formFields.openingTimes" placeholder="请输入开门次数..." size="small" number />
        </FormItem>
        <FormItem label="车库备注:" prop="remarks">
          <Input v-model="formFields.remarks" placeholder="请输入备注..." size="small" />
        </FormItem>
        <FormItem label="车库排序:" prop="sort">
          <Input v-model="formFields.sort" placeholder="请输入排序编号..." size="small" number />
        </FormItem>
        <FormItem label="地图定位:">
          <Button size="small" icon="ios-locate-outline" @click="showMap">
            {{ location ? '重新定位车库位置' : '定位车库位置' }}
          </Button>
        </FormItem>
        <input v-model="formFields.id" type="hidden" name="id"></input>
      </Form>
    </div>
    <div style="font-size: 12px; text-align: right; color: #69c">
      <Icon type="md-information-circle" /> 一旦容量保存后将不能进行扩容，且容量越大, 系统为车库分配车辆编号的时间越长。
    </div>
    <div slot="footer">
      <Button type="primary" :disabled="loadingStatus" size="small" icon="ios-checkmark-circle-outline" :loading="submit" @click="saveOrUpdate">
        保存
      </Button>
    </div>
    <VBaiduMap :visible="modalMap" :data="location" @on-marked="onMapMarked" @on-close="onMapClose" />
  </Modal>
</template>

<script>
import AreaCascader from '@/components/area-cascader'
import request from '@/utils/request'
import VBaiduMap from '@/components/vmap'
import { applyObject } from '@/utils/util'
export default {
  name: 'ParkingDialog',
  components: { VBaiduMap, AreaCascader },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    },
    action: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: 0
    },
    onlineDate: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      file: null,
      location: undefined,
      loadingStatus: false,
      defaultList: [],
      modal: true,
      modalMap: false,
      submit: false,
      area: [],
      formFields: {
        name: '',
        type: 0,
        isFresh: 0,
        isOpen: 1,
        bufferMonths: 3,
        openingTimes: 4,
        businessType: 0,
        remarks: '',
        latitude: 0,
        longitude: 0,
        address: '',
        province: '',
        city: '',
        district: '',
        capacity: 20000,
        sort: 0,
        id: this.id,
        onlineDate: ''
      },
      ruleValidate: {
        type: [{ required: true, message: '车库类型不能为空' }],
        capacity: [{ required: true, message: '车库容量不能为空' }],
        openingTimes: [{ required: true, message: '开门次数不能为空' }],
        name: [{ required: true, message: '车库名不能为空!', trigger: 'blur' }],
        onlineDate: [{ required: true, message: '车库运营日期不能为空!!', trigger: 'blur' }]
      }
    }
  },
  computed: {
    segmentCapacity() {
      return this.$config.segmentCapacity
    },
    parkingTypes() {
      return this.$config.parkingTypes
    },
    parkingFreshTypes() {
      return this.$config.parkingFreshTypes
    },
    parkingOpenTypes() {
      return this.$config.parkingOpenTypes
    },
    parkingBusinessType() {
      return this.$config.parkingBusinessType
    },
    title() {
      if (this.caption) {
        return this.caption
      } else {
        return this.id ? '编辑车库' : '添加新车库'
      }
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    }
  },
  watch: {

    showModal(val) {
      this.resetForm()
      this.loadingStatus = false
      if (this.action && this.id) {
        this.loadingStatus = true
        request({
          url: this.action + '/' + this.id,
          method: 'get'
        }).then(res => {
          this.loadingStatus = false
          // this.formFields = res.data
          applyObject(res.data, this.formFields)
          this.formFields = { ...this.formFields, isFresh: res.data.isFresh ? 1 : 0, isOpen: res.data.isOpen ? 1 : 0 }
          const { province, city, district, latitude, longitude, address } = this.formFields
          if (province && city && district) {
            this.area = [province, city, district]
          }
          if (latitude && longitude) {
            this.location = { address: address, lat: latitude, lng: longitude }
          }
        }).catch(() => {
          // this.$Notice.error({
          //   title: '服务器数据请求失败',
          //   desc: '请求地址: ' + this.action + ', 错误信息: ' + error
          // })
          this.loadingStatus = false
        })
      }
    }
  },
  methods: {
    handleCapacityChange(val) {
    },
    showMap() {
      this.modalMap = true
    },
    onAreaChange(data) {
      if (data.length > 0 && data.length === 3) {
        this.formFields = { ...this.formFields, province: data[0], city: data[1], district: data[2] }
      } else {
        this.formFields = { ...this.formFields, province: '', city: '', district: '' }
      }
    },
    onMapClose() {
      this.modalMap = false
    },
    onMapMarked(location) {
      this.location = location
      this.formFields = { ...this.formFields, address: location.address, latitude: location.lat, longitude: location.lng }
      this.modalMap = false
    },
    handleDateChange: function(date) {
      this.formFields.onlineDate = date
    },
    resetForm: function() {
      this.$refs.parkingForm.resetFields()
      this.formFields.id = 0
      this.formFields.onlineDate = ''
      this.formFields.province = ''
      this.formFields.city = ''
      this.formFields.district = ''
      this.formFields.address = ''
      this.location = undefined
      this.modalMap = false
      this.area = []
    },
    saveOrUpdate: function() {
      if (this.action) {
        this.$refs.parkingForm.validate((valid) => {
          if (valid) {
            this.submit = true
            const isNew = this.formFields.id === 0
            request({
              url: this.action + (isNew ? '' : ('/' + this.id)),
              method: isNew ? 'POST' : 'PUT',
              data: this.formFields
            }).then(res => {
              this.loadingStatus = false
              this.formFields = res.data
              this.$Notice.success({ title: '数据保存成功', desc: '车库 `' + this.formFields.name + '` 保存成功!' })
              this.submit = false
              this.closeModal(true)
            }).catch(() => {
              // this.$Notice.error({
              //   title: '服务器数据请求失败',
              //   desc: '请求地址: ' + this.action + ', 错误信息: ' + error
              // })
              this.loadingStatus = false
              this.submit = false
            })
          }
        })
      }
    },
    closeModal: function(changed = false) {
      this.$emit('on-close', changed)
    }
  }
}
</script>
